"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommunityOnline = void 0;
var _core = require("./core");
const isCommunityOnline = async name => {
  if (!name) {
    return false;
  }
  try {
    const communities = await _core._Api.get('/communities/public?name=' + name);
    if (communities.data && communities.data['hydra:totalItems'] && communities.data['hydra:totalItems'] === 0) {
      return false;
    }
    let isExisting = false;
    communities.data['hydra:member'].forEach(community => {
      if (community.name === name) {
        isExisting = true;
      }
    });
    return isExisting;
  } catch (e) {
    console.error('Cannot get public communities', e);
  }
  return false;
};
exports.isCommunityOnline = isCommunityOnline;